<template>
  <v-container pa-0>
    <v-row class="ml-3 mt-n9">
      <div class='headline'>Форма обращения по поводу коррупционного правонарушения</div>
    </v-row>
    <v-form v-model="messageForm" ref="form">
      <v-row class="mt-4" justify="center">
        <v-col cols=12 align="center">
          <v-card elevation="1" max-width='1000'>
            <v-row class="mx-7 pt-5">
              <v-col cols=12 sm=6>
                <v-text-field label="Ф.И.О. лица, направившего уведомление" v-model="name" :rules="[rules.required]" dense></v-text-field>
              </v-col>
              <v-col cols=12 sm=6>
                <v-text-field type="tel" label="Телефон лица, направившего уведомление" placeholder="+7 (999) 999-9999" :rules="[rules.required, rules.phone]" maxlength="17" v-model="phone" v-mask="['+7 (', /\d/, /\d/, /\d/, ') ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/]" dense></v-text-field>
              </v-col>
            </v-row>
            <v-row class="mx-7">
              <v-col cols=12 sm=6>
                <v-autocomplete label="Населённый пункт" :items="suggestionsCity" :search-input.sync="cityQuery" v-model="city" dense return-object item-text="text" :rules="[rules.required]"></v-autocomplete>
              </v-col>
              <v-col cols=12 sm=6>
                <v-autocomplete label="Улица" :items="suggestionsStreet" :search-input.sync="streetQuery" v-model="street" dense return-object item-text="text" :rules="[rules.required]"></v-autocomplete>
              </v-col>
            </v-row>
            <v-row class="mx-7">
              <v-col cols=12 sm=6>
                <v-autocomplete label="Дом" :items="suggestionsHouse" :search-input.sync="houseQuery" v-model="house" dense return-object item-text="text" :rules="[rules.required]"></v-autocomplete>
              </v-col>
              <v-col cols=12 sm=6>
                <v-text-field label="Квартира" v-model="flat" dense item-text="text"></v-text-field>
              </v-col>
            </v-row>
          </v-card>
        </v-col>
      </v-row>
      <v-row class="mt-4" justify="center">
        <v-col cols=12 align="center">
          <v-card elevation="1" max-width='1000'>
            <v-toolbar color="accent" dark dense elevation="0">
              <v-toolbar-title>Текст обращения</v-toolbar-title>
            </v-toolbar>
            <v-textarea class="mx-2 mt-1 mb-n3 message-input ml-7" placeholder="Текст" v-model="message" prepend-icon="mdi-comment" rounded rows="11" :rules="[rules.required]"></v-textarea>
            <v-divider class="mt-4 ml-7 mr-7" style="border-color: rgba(0, 0, 0, .39)"></v-divider>
            <v-textarea class="mx-2 mt-1 mb-n3 message-input ml-7" :placeholder="messageSample" rounded no-resize prepend-icon="a" rows="8" readonly style="font-size: 1.1em"></v-textarea>
            <v-card-actions class="pb-0">
              <v-file-input dense multiple label="Прикрепить файл (макс. размер 10МБ)" class="pt-3 ml-4 mr-4" v-model="files" style="width: 180px" :rules="[rules.fileSize]"></v-file-input>
            </v-card-actions>
            <v-card-actions class="pb-3">
              <v-checkbox v-model="consent" class="ml-4" :rules="[v => !!v || 'Для сохранения заявки необходимо согласие на обработку персональных данных']" label="Я согласен на обработку и хранение моих персональных данных" required></v-checkbox>
              <v-spacer></v-spacer>
              <v-btn color="orange" text @click="saveQuestion" :disabled="searchDialog">
                Отправить
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-col>
      </v-row>
    </v-form>
    <request-dialog v-model="searchDialog" message="Выполняется запрос..." />
  </v-container>
</template>
<script>
import { mapGetters } from 'vuex'
import { convertDate, parseDate, downloadFile, fileListToBase64, _base64ToArrayBuffer, cleanNumber, suggestAddress } from '@/utils'

export default {
  name: 'Ticket',

  props: {
    ticketId: {
      type: Number,
      default: undefined
    },
    typeId: {
      type: Number,
      default: undefined
    },
    isOperator: {
      type: Boolean,
      default: false
    }
  },

  data: () => ({
    searchInput: '',
    rules: {
      required: value => !!value || 'Обязательное поле',
      fileSize: function(v) {
        return (v.length == 0 || v.reduce(function(previousValue, currentValue, index, array) {
          return previousValue + currentValue.size
        }, 0) <= 10485760) || 'Размер файла превышает 10МБ'
      },
      email: value => {
        const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        return pattern.test(value) || 'Неверный формат e-mail'
      },
      accountNumber: v => !v || /^(\d{3}(-)){3}(\d){3}$/.test(v) || 'Формат: 000-000-000-000',
      phone: v => !v || v.length == 17 || 'Номер телефона в формате +7 (999) 999-9999',
      address: v => !v || (v.object.data.house != null || 'Населённый пункт, ул XXXXX, д XX(, кв ХХ)')
    },
    message: null,
    messageSample: 'Рекомендованная форма обращения\n\n- Данные о лице, склоняющем к совершению коррупционного правонарушения\n- Сущность предполагаемого коррупционного правонарушения\n- Способ склонения к совершению коррупционного правонарушения\n- Дата, место, время склонения к совершению правонарушения\n- Обстоятельства склонения к совершению правонарушения\n- Дополнительная информация, имеющаяся по факту склонения к совершению коррупционных правонарушений',
    files: [],
    searchDialog: false,
    dadataToken: process.env.VUE_APP_DADATA_TOKEN || '',
    messageForm: false,
    suggestions: [],
    consent: false,
    name: null,
    phone: null,
    suggestionsCity: [],
    suggestionsStreet: [],
    suggestionsHouse: [],
    addressQuery: null,
    cityQuery: null,
    streetQuery: null,
    houseQuery: null,
    city: null,
    street: null,
    house: null,
    flat: null
  }),

  computed: {
    ...mapGetters({
      userLogin: 'user/userLogin',
      userRoles: 'user/userRoles',
      ticketTypes: 'common/ticketTypes'
    }),
    isSuperuser: function() {
      return this.userRoles.includes('superuser')
    },
    isIE: function() {
      let ua = navigator.userAgent
      /* MSIE used to detect old browsers and Trident used to newer ones*/
      let is_ie = ua.indexOf("MSIE ") > -1 || ua.indexOf("Trident/") > -1
      return is_ie
    },
    address: function() {
      if (this.city != null && this.street != null && this.house != 0) {
        if (this.flat != null) return `${this.city.text}, ${this.street.text}, ${this.house.text}, кв ${this.flat}`
        else return `${this.city.text}, ${this.street.text}, ${this.house.text}`
      } else return null
    }
  },

  watch: {
    cityQuery: async function(value) {
      this.getSuggestions(value, 'city', 'settlement')
    },
    streetQuery: async function(value) {
      this.getSuggestions(value, 'street', 'street')
    },
    houseQuery: async function(value) {
      this.getSuggestions(value, 'house', 'house')
    }
  },

  methods: {
    getSuggestions: async function(value, from_bound, to_bound) {
      if (this.isLoading) return
      this.isLoading = true
      try {
        let locations = {}
        switch (from_bound) {
          case 'city':
            locations.region = "приморский"
            break
          case 'street':
            if (this.city != null) {
              if (this.city.object.data.city_fias_id != null) locations.city_fias_id = this.city.object.data.city_fias_id
              else locations.settlement_fias_id = this.city.object.data.settlement_fias_id
            } else locations.region = "приморский"
            break
          case 'house':
            if (this.street != null) locations.street_fias_id = this.street.object.data.street_fias_id
            else if (this.city != null) {
              if (this.city.object.data.city_fias_id != null) locations.city_fias_id = this.city.object.data.city_fias_id
              else locations.settlement_fias_id = this.city.object.data.settlement_fias_id
            } else locations.region = "приморский"
            break
        }
        let resp = await suggestAddress(value, this.dadataToken, locations, from_bound, to_bound)
        switch (from_bound) {
          case 'city':
            this.suggestionsCity = resp
            break
          case 'street':
            this.suggestionsStreet = resp
            break
          case 'house':
            this.suggestionsHouse = resp
            break
        }
        this.isLoading = false
      } catch (e) {
        console.log('Невозможно получить адреса')
        this.isLoading = false
      }
    },
    saveQuestion: async function() {
      let isValid = this.$refs.form.validate()
      if (isValid) {
        this.searchDialog = true
        try {
          let fileArray = []
          let fileObjs = []
          if (this.files) {
            fileArray = await fileListToBase64(this.files)
            for (let i = 0; i < this.files.length; i++) fileObjs.push({ name: this.files[i].name, file: fileArray[i] })
          }
          let message_obj = {
            'name': this.name,
            'address': this.address,
            'phone': this.phone,
            'message': this.message,
            'is_user': !this.isOperator,
            'user': this.userLogin,
            'files': fileObjs,
            'position': null,
            'type_id': 6
          }
          const resp = await this.$api.Account.saveQuestion(message_obj)
          this.$router.push({ path: `/tickets/my_tickets/${resp.data['code']}` })
          this.searchDialog = false
        } catch (e) {
          const err = e
          this.searchDialog = false
          if (e.response.status == 401) {
            await this.$store.dispatch('user/authLogOut')
            location.href = location.href
          }
          let error = 'Не удалось сохранить обращение'
          await this.$store.dispatch('notification/setSystemNotification', { message: error, type: 'error' })
          console.error(e)
        }
      }
    }
  },
}

</script>
<style scoped>
a {
  text-decoration: none;
  color: #101010;
}

a:hover,
a:hover>.v-icon {
  color: orange;
}

.round-icon {
  color: white;
  display: block;
  margin-left: auto;
  margin-right: auto;
  font-size: 20pt;
  height: 70px;
}

.round-icon-back {
  margin-top: 10px;
  margin-bottom: -20px;
  display: block;
  margin-left: auto;
  margin-right: auto;
  height: 70px;
  width: 70px;
  border-radius: 50%;
  background-color: #005caf;
}

.message-input .v-input__slot {
  border-style: none !important;
}

.message-file {
  font-size: 10pt;
  color: #005caf;
  text-decoration: underline;
  cursor: pointer;
}

</style>
